import * as React from 'react'
import classNames from 'classnames'

import { SearchInputProps } from '../SearchInput/index'

import SearchButton, {
  DEFAULT_CLOSE_ICON_LABEL_TEXT,
  DEFAULT_SEARCH_ICON_LABEL_TEXT,
} from '../SearchButton/index'
import SearchInput from '../SearchInput/index'
import { createSearchForm } from '../helpers'

import style from './style.scss'

export type Props = SearchInputProps & {
  apiKey: string
  className?: string
  closeIconLabelText?: string
  searchIconLabelText?: string
}

type State = {
  isHidden: boolean
}

class SearchBarPopup extends React.PureComponent<Props, State> {
  static defaultProps = {
    className: '',
    closeIconLabelText: DEFAULT_CLOSE_ICON_LABEL_TEXT,
    searchIconLabelText: DEFAULT_SEARCH_ICON_LABEL_TEXT,
  }

  searchRef: { current: HTMLDivElement | null } = React.createRef()

  focusTimer: NodeJS.Timeout | null = null

  state = {
    isHidden: true,
  }

  componentDidMount() {
    const { apiKey } = this.props
    createSearchForm(apiKey)
  }

  componentWillUnmount(): void {
    if (this.focusTimer) {
      clearTimeout(this.focusTimer)
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    const hasHiddenUpdatesToTrue = !prevState.isHidden && this.state.isHidden
    const hasHiddenUpdateToFalse = prevState.isHidden && !this.state.isHidden
    const hasHiddenUpdate = hasHiddenUpdatesToTrue || hasHiddenUpdateToFalse

    // Escape if hidden is not updated
    if (!hasHiddenUpdate) {
      return
    }

    // Cancel timer nullify to avoid timer duplication
    if (this.focusTimer) {
      clearTimeout(this.focusTimer)
      this.focusTimer = null
    }

    /*
      Add Timer to resolve .focus() lag
      Notes:
      - Animation lag occurs on App Load (unavoidable)
       - mainly on load of React App
       - during element animation will create GPU lag on Android
     */
    if (hasHiddenUpdate) {
      this.focusTimer = setTimeout(() => this.handleCursorFocus(prevState), 500)
    }

    if (hasHiddenUpdatesToTrue) {
      document.removeEventListener('click', this.handleCloseListener)
    }

    if (hasHiddenUpdateToFalse) {
      document.addEventListener('click', this.handleCloseListener)
    }
  }

  handleCloseListener = (event: MouseEvent) => {
    const { current } = this.searchRef
    const { isHidden } = this.state
    if (current) {
      const isInsideSearchPopup = current.contains(event.target as Node)
      if (!isInsideSearchPopup && !isHidden) {
        this.handleToggleSearchBar()
      }
    }
  }

  handleToggleSearchBar = () => {
    this.setState((state) => ({ isHidden: !state.isHidden }))
  }

  handleCursorFocus = (prevState: State) => {
    const { isHidden } = this.state
    const { current } = this.searchRef
    if (prevState.isHidden !== isHidden && current) {
      // Desktop Moves cursor into input and iOS and Android browser keyboard opening/closing
      // input does not need to blur since a click will move focus away from input
      const input = current.querySelector('input')
      if (!input) {
        return
      }
      if (!isHidden) {
        input.focus()
      }
    }
  }

  // /**
  //  * @description This function send a click event to the google form button which is isHidden
  //  */
  // handleSubmit = () => {
  //   const googleCustomSearch = document.getElementById(
  //     'google-custom-search-input',
  //   )
  //   if (googleCustomSearch) {
  //     const btn = googleCustomSearch.getElementsByTagName('button')[0]
  //     if (btn) {
  //       btn.click()
  //     }
  //   }
  // }

  render() {
    const { isHidden } = this.state
    const {
      className,
      closeIconLabelText,
      searchIconLabelText,
      ...inputProps
    } = this.props
    return (
      <div
        ref={this.searchRef}
        className={classNames(style.wrapper, className)}
        role='search'
      >
        <SearchButton
          closeIconLabelText={closeIconLabelText}
          isActive={!isHidden}
          searchIconLabelText={searchIconLabelText}
          onClick={this.handleToggleSearchBar}
        />
        <div className={style.fullBleedWrapper}>
          <SearchInput
            {...inputProps}
            className={classNames(style.popupBar, { [style.hidden]: isHidden })} // hidden is an extended class of %slide-utility-transition
          />
        </div>
      </div>
    )
  }
}

export default SearchBarPopup
